import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { ApiRequestFunction } from 'utils/request/useApi';
import type { WebHooksState } from '../WebHooksState';

export function makeLoadWebHooks(
  updateState: DraftStateUpdater<WebHooksState>,
  apiRequest: ApiRequestFunction,
) {
  // `background` refreshes the data without flipping `dataFetching` — used when
  // a list mutation (e.g. the active toggle) must resync the webhooks array that
  // feeds the editor, without flashing the full-page loader.
  return async ({
    background,
  }: { background?: boolean } = {}): Promise<void> => {
    try {
      if (!background) {
        updateState((draft) => {
          draft.dataFetching = true;
        });
      }

      const [webhooks, eventTypes] = await Promise.all([
        apiRequest({
          url: '/webhooks',
          method: 'GET',
        }),
        apiRequest({
          url: '/webhooks/types',
          method: 'GET',
        }),
      ]);

      updateState((draft) => {
        if (Array.isArray(webhooks)) {
          draft.webhooks = webhooks;
        }
        if (Array.isArray(eventTypes)) {
          draft.eventTypes = eventTypes;
        }
      });
    } finally {
      if (!background) {
        updateState((draft) => {
          draft.dataFetching = false;
        });
      }
    }
  };
}
